/**
 * 
 * @param map object to map
 * @param lowerMap lowerMapping ref
 */
const lowerMapper = (map: any, lowerMap: any) =>
	Object.keys(map).reduce((memo: any, key: any) => {
		const value = map[key];

		if (Array.isArray(value)) {
			return { ...memo, [key]: value };
		}

		const keySplt = String(value).split(',');
		return {
			...memo,
			[key]:
				key !== 'sort' || !lowerMap[keySplt[0]]
					? value
					: `${lowerMap[keySplt[0]]}${keySplt[0] ? `,${keySplt[1]}` : ''}`
		};
	}, {});

export default lowerMapper;
